import { render, staticRenderFns } from "./cell-author.vue?vue&type=template&id=67aeb13b"
import script from "./cell-author.vue?vue&type=script&lang=js"
export * from "./cell-author.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports